var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgStorefrontFilled = function SvgStorefrontFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillRule: "evenodd",
    d: "M20.003 11.62v9.384-9.383ZM22.004 21.004H1.996h20.008ZM3.997 11.619v9.385-9.385ZM7.498 9.749A2.251 2.251 0 0 1 5.248 12l2.25-2.251Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillRule: "evenodd",
    d: "M12 9.749a2.251 2.251 0 0 1-4.502 0M16.502 9.749a2.251 2.251 0 0 1-4.502 0",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillRule: "evenodd",
    d: "M18.753 12a2.25 2.25 0 0 1-2.251-2.251L18.752 12Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillRule: "evenodd",
    d: "M18.753 12a2.25 2.25 0 0 0 2.25-2.251v-.127c0-.408-.11-.808-.32-1.158l-2.101-3.496a2 2 0 0 0-1.712-.971H7.13a2 2 0 0 0-1.716.971l-2.1 3.496c-.21.35-.32.75-.318 1.158v.127A2.251 2.251 0 0 0 5.247 12",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M20.003 11.62v9.384m2.001 0H1.996m2-9.385v9.385m3.002 0V15.5a.5.5 0 0 1 .5-.5H10a.5.5 0 0 1 .5.5v5.503m3.502-3.002h3.001a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-3.001a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5ZM7.498 9.75a2.251 2.251 0 1 1-4.502 0v-.127a2.245 2.245 0 0 1 .317-1.158l2.101-3.496a2 2 0 0 1 1.716-.971h9.74a2 2 0 0 1 1.712.971l2.1 3.496c.21.35.322.75.322 1.158v.127a2.25 2.25 0 1 1-4.502 0 2.251 2.251 0 0 1-4.502 0 2.251 2.251 0 0 1-4.502 0Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStorefrontFilled);
export default ForwardRef;